<template>
  <div v-if="show" class="inline-block right-0 top-0 w-full p-5 sm:p-8 sm:max-w-md fixed z-10">
    <div class="relative bg-white dark:bg-gray-900 ring-1 ring-black/10 rounded-lg shadow-lg py-4 px-5">
      <component :is="steps[currentStep]" class="leading-relaxed text-gray-600 max-w-lg space-y-1"/>

      <l-button
        class="absolute top-2 right-2 p-2 leading-none text-gray-400 hover:text-gray-600"
        aria-label="Close alert"
        @click="close"
      >
        <icon name="close" class="text-xs"/>
      </l-button>

      <div class="flex mt-3" :class="currentStepIndex > 0 ? 'justify-between': 'justify-end'">
        <l-button
          v-if="currentStepIndex > 0"
          size="sm"
          variant="light"
          class="justify-self-start"
          @click="back"
        >
          <icon name="previous" class="text-xs"/>
          Previous
        </l-button>
        <l-button
          v-if="currentStepIndex < maxSteps"
          size="sm"
          variant="light"
          class="justify-self-end"
          @click="next"
        >
          <icon name="next" class="text-xs"/>
          Next tip
        </l-button>

        <l-button
          v-else
          size="sm"
          variant="light"
          class="justify-self-end"
          @click="close"
        >
          Close
        </l-button>
      </div>
    </div>
  </div>
</template>

<script setup>
// eslint-disable-next-line no-unused-vars
import Icon from "@/components/Icon.vue"
import LButton from "@/components/buttons/LButton.vue"
import { computed, onMounted, ref } from "vue"

const props = defineProps({
  heading: String,
  steps: { type: Object, required: true },
})

const maxSteps = computed(() => Object.keys(props.steps).length - 1)

const show = ref(true)

const currentStep = ref()
const currentStepIndex = ref(0)

const close = () => show.value = false

const back = () => {
  currentStepIndex.value -= 1
  currentStep.value = Object.keys(props.steps)[currentStepIndex.value]
}

const next = () => {
  if (currentStepIndex.value >= maxSteps.value) {
    return
  }

  if ((maxSteps.value - currentStepIndex.value) <= 1) {
    currentStepIndex.value += 1
    currentStep.value = Object.keys(props.steps)[currentStepIndex.value]
  } else {
    currentStepIndex.value += 1
    currentStep.value = Object.keys(props.steps)[currentStepIndex.value]
  }
}

onMounted(() => {
  currentStep.value = Object.keys(props.steps)[0]
})
</script>
